module.exports = __webpack_public_path__ + "static/assets/8d39abf97a1adea074cccde6cf1b7718.svg";